import { render, staticRenderFns } from "./zhiqinguserlist.vue?vue&type=template&id=122406a6&scoped=true"
import script from "./zhiqinguserlist.vue?vue&type=script&lang=js"
export * from "./zhiqinguserlist.vue?vue&type=script&lang=js"
import style0 from "./zhiqinguserlist.vue?vue&type=style&index=0&id=122406a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122406a6",
  null
  
)

export default component.exports